/** @format */

import {IconButton, Popover} from '@sttark/design-system';
import Moment from 'moment/moment';
import React from 'react';
import {SHIPPING_PROVIDER_NONE} from 'frontier-constants';

export const ShowEstimatedArrival = ({shipment}) => {
    // Check for local pickup - handle both empty string and 'none' as provider values
    const isLocalPickup =
        (shipment.shipping_method_provider === SHIPPING_PROVIDER_NONE ||
            shipment.shipping_method_provider === 'none') &&
        shipment.shipping_method_code === '01';
    const labelText = isLocalPickup ? 'Estimated Pickup' : 'Estimated Arrival';

    return (
        <div
            className={`mt-4 w-100 estimated-delivery d-flex align-items-center justify-content-between`}>
            <div>
                <div className="m-0 position-relative d-flex align-items-center justify-content-start flex-nowrap estimated-arrival-label-container">
                    <h6 className="m-0 tw-p-0 estimated-arrival-label">{labelText}</h6>
                    <div className="position-relative">
                        <Popover
                            title={
                                isLocalPickup
                                    ? 'How we calculate pickup times'
                                    : 'How we calculate arrival times'
                            }
                            content={
                                <p style={{width: 300}}>
                                    Order shipping is an estimation based on the purchase date and
                                    proof approval. {isLocalPickup ? 'Pickup' : 'Delivery'} date is
                                    also an estimation that may be impacted by{' '}
                                    {isLocalPickup ? 'production delays' : 'carrier delays'}.
                                </p>
                            }>
                            <div className="mb-2">
                                <IconButton small secondary icon="info" />
                            </div>
                        </Popover>
                    </div>
                </div>

                <h5 className="estimated-arrival color-accent-secondary m-0">
                    <span style={{fontFamily: 'verdana'}}>&rarr; </span>
                    {Moment(shipment.quoted_delivery_date).format('MMM D')}
                </h5>
            </div>
        </div>
    );
};
